import React, { useState, useEffect } from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import ChatbotPage from './components/ChatbotPage';
import SidebarNav from './components/SidebarNav';
import { AnimationProvider } from './context/AnimationContext';

function App() {
  const [userInfo, setUserInfo] = useState(null);
  const [emotionHistory, setEmotionHistory] = useState([]);
  const [isInitialConversationComplete, setIsInitialConversationComplete] = useState(false);

  useEffect(() => {
    // Clear user info on page load to require re-authentication
    setUserInfo(null);
  }, []);

  const handleEmailSubmit = async (submittedUserInfo) => {
    try {
      // The user is already authenticated by LandingPage.js
      setUserInfo({
        email: submittedUserInfo.email,
        firstName: submittedUserInfo.firstName
      });
      
      // Initialize empty emotion history if none provided
      setEmotionHistory([]);
      setIsInitialConversationComplete(false);
      
    } catch (error) {
      console.error('Auth Error:', error);
      throw error;
    }
  };

  // Calculate the number of unique emotions, excluding discarded emotions
  const uniqueEmotionCount = new Set(
    emotionHistory
      .filter(item => !item.isDiscarded)
      .map(item => item.emotion_result)
  ).size;

  return (
    <AnimationProvider>
      <div className="App">
        {!userInfo ? (
          <LandingPage onEmailSubmit={handleEmailSubmit} />
        ) : (
          <>
            <ChatbotPage 
              userInfo={userInfo} 
              emotionHistory={emotionHistory}
              setEmotionHistory={setEmotionHistory}
              setIsInitialConversationComplete={setIsInitialConversationComplete}
            />
            {userInfo && (
              <SidebarNav 
                userInfo={userInfo}
                emotionCount={uniqueEmotionCount}
              />
            )}
            {emotionHistory.length > 0 && isInitialConversationComplete && (
              <div className="minimized-shapes ...">
                {/* ... existing code ... */}
              </div>
            )}
          </>
        )}
      </div>
    </AnimationProvider>
  );
}

export default App;
